(function () {
  'use strict';

  function syncSelectedLabel(root) {
    if (!root) return;

    var selectedLabel = root.querySelector('[data-pdp-variants-selected]');
    if (!selectedLabel) return;

    var selectedSwatch =
      root.querySelector('[data-pdp-variant-link].is-selected') ||
      root.querySelector('[data-pdp-variant-link][aria-current="true"]');

    if (!selectedSwatch) return;

    var shadeName = selectedSwatch.getAttribute('data-shade-name');
    if (shadeName) {
      selectedLabel.textContent = shadeName;
    }
  }

  function initVariants(root) {
    if (!root || root.dataset.pdpVariantsInit === 'true') {
      syncSelectedLabel(root);
      return;
    }
    root.dataset.pdpVariantsInit = 'true';

    var selectedLabel = root.querySelector('[data-pdp-variants-selected]');
    var links = root.querySelectorAll('[data-pdp-variant-link]');

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        var shadeName = link.getAttribute('data-shade-name');
        if (shadeName && selectedLabel) {
          selectedLabel.textContent = shadeName;
        }
      });
    });

    syncSelectedLabel(root);
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-pdp-variants]').forEach(initVariants);
  }

  function syncAll() {
    document.querySelectorAll('[data-pdp-variants]').forEach(syncSelectedLabel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // bfcache restore keeps the pre-navigation label mutation; re-derive from selected swatch
  window.addEventListener('pageshow', syncAll);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
